<template>
  <mw-dialog size="large_large" title="修改字段" :footerButton="footerButton" ref="dialog" @closed="handleClose">

    <el-tabs value="first">
      <el-tab-pane label="普通字段" name="first">
        <div style="height:100%;overflow:auto;">
          <mw-form-view :businessId="businessId" :appId="applicationId" :moduleId="moduleId" :value.sync="value" ref="formView" @handleField="handleField" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="隐藏字段" name="second">
        <div style="height:100%;overflow:auto;">
          <table style="width:100%;border-collapse: separate;border-spacing:10px 10px;">
            <tbody>
              <tr v-for="name in nameList" :key="name">
                <td style="text-align:left;width:180px;">{{name}}</td>
                <td>
                  <el-input type="textarea" :rows="1" v-model="hiddenFields[name]"></el-input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </mw-dialog>
</template>

<script>
import api from "@/common/api/maintain";
export default {
  data() {
    return {
      footerButton: [
        {
          label: "确定",
          func: async () => {
            await this.submit();
            this.mwMsg("修改成功");
            this.$emit('updateTable');
            this.mwRef("dialog").hide();
          }
        },
        {
          label: "取消",
          func: () => {
            this.mwRef("dialog").hide();
          }
        }
      ],
      nameList: [],
      hiddenFields: {},
      businessId: "",
      applicationId: "",
      moduleId: "",
      value: {},
      formKey: "",
      formId: "",
      batchId:""
    };
  },

  watch: {
    "value.initformid"(formId) {
      this.formId = formId;
    },

    formId(formId) {
      this.getHiddenFields();
    }
  },
  mounted() {

  },
  methods: {
    async submit() {
      var ofc=this.$refs.formView.formInst.find("office_zw");
      if(ofc && ofc.getEl().find("iframe").length>0){
         ofc.saveToServer({},true);
      }
      return api.saveFormData({
        $form: {
          ...this.$refs.formView.formData(),
          ...this.hiddenFields
        },
        // appId: this.applicationId,
        businessId: this.businessId,
        formKey: this.formKey,
        moduleId: this.moduleId,
        batchId:this.batchId
      });

    },

    async action({ applicationId, businessId, moduleId, formEntityKey,batchId }) {
      this.mwRef("dialog").show();
      this.businessId = businessId;
      this.applicationId = applicationId;

      this.moduleId = moduleId;
      this.formKey = formEntityKey;
      this.batchId=batchId;
      //
      // this.getFormData().then(v=>{
      //   this.getHiddenFields();
      // });
    },

    handleClose() {
      // this.$refs.formView.teardown();
    },
    async getFormData(){
       let me=this;
      const { result } = await this.mwApi.config.moduleConfig({
        dataId: this.businessId
          ? this.businessId
          : this.tempBusinessId
            ? `_${this.tempBusinessId}`
            : "",
        taskId: this.taskId,
        processDefinitionId: this.taskId ? this.processDefinitionId : "",
        activityId: this.taskId ? this.activityId : "",
        processDefinitionId: this.flowKey,
        flowFlag: false,
        forceModuleForm: false,
        moduleId: this.moduleId,
        appId: this.appId,
        draftsDocId: this.draftsDocId
      });
      this.value=result.formData;
      return result.formData;
    },
    handleField(item) {
      if (!item.isContainer) return;
      if (item.isContainer()) return;
      if (item.items) return;
      if (!item.isFormField) return;
      if (item.isFormField()) return;
      const { xtype } = item;
      switch (xtype) {
        case "Description":
        case "OfficeControl":
        case "RelFileSelection":
        case "Label": {
          break;
        }
        default: {
          
          item.setHidden(true);
        }
      }
    },

    async getHiddenFields() {
      const {
        result: formData,
        success
      } = await this.mwApi.maintain.getHiddenFormData({
        businessId: this.businessId,
        formKey: this.formKey,
        formId: this.formId,
        applicationId:this.applicationId,
        $form: {},
        moduleId: this.moduleId
      });
      this.nameList = formData.map(x => x.name+"("+x.id+")").sort();
      this.hiddenFields = formData.reduce((p, c) => {
        return {
          ...p,
          [c.name +"("+c.id+")"]: "" + (this.value[c.id||""]||"")
        };
      }, {});

    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/changeFormData.vue